// 查询权限列表
export const getScopeList = (appId, appType) => {
  const scopeUrl = {
    innerapp: "apps",
    isv: "isv/apps"
  };
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${scopeUrl[appType]}/auth/scopes/${appId}`,
    { method: "GET" }
  );
};
const infoData = {
  baseIsFinish: 1, //基础信息   2未完成 1已完成
  addDeveloper: 1, //添加成员   0未完成 1已完成
  addBetaVersion: 2, //上传开发版 1已上传 2未上传
  isPublish: 2, //发布版本   1已发布 2未发布
  interfacePermissions: 2, //接口权限     1已开通 2未开通
  homeURL: 2, //设置首页地址 1已设置 2未设置
  setAuthorization: 2, //设置授权     1已设置 2未设置
  setwhiteIps: 2, //设置IP白名单     1已设置 2未设置
  preAuditInfoStatus: 2, //提交预审     1已提交 2未提交
  PublishTrialVersion: 2, //发布体验版   1已发布 2未发布
  ShelvesApplication: 2, //上架应用     1已上架 2未上架
  errorMsg: "获取数据失败，请稍后重试"
};

// 获得回调地址
export const getCallBack = (appId, appType) => {
  const callBackUrl = {
    innerapp: "apps",
    isv: "isv/apps"
  };
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${callBackUrl[appType]}/manage/config/${appId}`,
    { method: "GET" }
  );
};

// 设置权限
export const setScope = (appId, scopeId, appType) => {
  const scopeUrl = {
    innerapp: "apps",
    isv: "isv/apps"
  };
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/${scopeUrl[appType]}/auth/scopes/${appId}`,
    { method: "POST", body: { scopeId: scopeId } }
  );
};

// 取消授权
export const cancelAuth = (appId, scopeId, appType) => {
  const authUrl = {
    innerapp: `service/apps/cancelAuth/${appId}?type=0`,
    isv: `service/apps/cancelAuth/${appId}?type=1`
  };
  return fetch(`/${process.env.REACT_APP_API_CONTEXT}/${authUrl[appType]}`, {
    method: "POST",
    body: { scopeId: scopeId }
  });
};

// 获取是否实名认证等基本信息
export const handleTenantInfo = () => {
  return fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/tenant/tenantInfo`,
    {
      method: "GET"
    }
  );
};

// 查询权限点成员接口
export const getCommonPermission = async params => {
  const { tenantId, objectId, namespace, action, pageSize, pageNum } = params;
  const result = await fetch(
    `/${process.env.REACT_APP_API_CONTEXT}/service/system/scope-api-transmission`,
    {
      method: "POST",
      body: {
        method: "POST",
        path: `/weac/admin/v1/visiblescope/commonPermission?pageSize=${pageSize}&pageNum=${pageNum}`,
        body: {
          tenantId,
          objectId,
          namespace,
          action
        }
      }
    }
  );
  return result;
};

///获得状态-内部
export const GetStatusThunk_in = async (appId, appType) => {
  try {
    const res = await fetch(
      `/${
        process.env.REACT_APP_API_CONTEXT
      }/service/myAppService/config/status/${appId}?appType=${appType}&a=${new Date().getTime()}`,
      { method: "GET" }
    );
    if (res.status == 1) {
      return {
        baseIsFinish: 1, //基础信息   2未完成 1已完成
        addDeveloper: 1, //添加成员   0未完成 1已完成
        addBetaVersion: res.data.devVersionInfoStatus == 1 ? 1 : 2, //上传开发版 1已上传 2未上传
        isPublish: res.data.releaseVersionInfoStatus == 1 ? 1 : 2, //发布版本   1已发布 2未发布
        interfacePermissions: res.data.authorityInfoStatus == 1 ? 1 : 2, //接口权限     1已开通 2未开通
        homeURL: res.data.indexUrlInfoStatus == 1 ? 1 : 2, //设置首页地址 1已设置 2未设置
        setAuthorization: res.data.authorityInfoStatus == 1 ? 1 : 2, //设置授权     1已设置 2未设置
        setwhiteIps:
          res.data.whiteIpsInfoStatus && res.data.whiteIpsInfoStatus == 1
            ? 1
            : 2, //设置IP白名单  1已设置 2未设置
        preAuditInfoStatus:
          res.data.preAuditInfoStatus && res.data.preAuditInfoStatus == 1
            ? 1
            : 2, //提交预审     1已提交 2未提交
        PublishTrialVersion: 2, //发布体验版   1已发布 2未发布
        ShelvesApplication: 2 //上架应用     1已上架 2未上架
      };
    } else {
      return infoData;
    }
  } catch (error) {
    return infoData;
  }
};
